import React from "react";
import "./custom-checkbox.style.scss";
export default function CustomCheckBox({
  title,
  error,
  handleChange = ()=>{},
  list,
  selected,
}) {
  return (
    <div className="custom-checkbox">
      <h6 style={error?{color: 'red'}:{}}>{title}</h6>
      <div>
        {list.map((obj) => (
          <label
            onClick={() => handleChange(obj)}
            className={obj.id === selected ? "checked" : ""}
          >
            <button type="button">
              <span />
            </button>
            <p>{obj.name}</p>
          </label>
        ))}
      </div>
    </div>
  );
}
